<div [@loadedHeightAnimation]="'visible'" class="cont__last_update">
  <div class="card pointer" [routerLink]="[model.Url]">
    <div class="card-title">
      <h5 class=" titular ">{{model.Title}}</h5>
    </div>
    <div clas="card-body">
      <p>{{model.Description}}</p>
    </div>
    <div class="card-footer">
      {{model.DataDate | date:'dd/MM/yyyy'}}
    </div>
  </div>
</div>